import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-registration.svg'
import _imports_1 from '@/assets/img/logo2.svg'
import _imports_2 from '@/assets/img/icons-img/lock.svg'
import _imports_3 from '@/assets/img/graphic/welcome-back.png'


const _withScopeId = n => (_pushScopeId("data-v-7afa7bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Back to Login ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header-logo",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Reset my password ")
const _hoisted_5 = {
  key: 1,
  class: "desktop--wrapper"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header--desktop" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desktop--container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo--desktop",
      src: _imports_1,
      alt: ""
    })
  ])
], -1))
const _hoisted_7 = { class: "desktop--container--sm" }
const _hoisted_8 = { class: "desktop--content" }
const _hoisted_9 = { class: "desktop--content--body" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--title-icon-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "desktop--title-icon",
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title--page" }, "Set a new password", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text--page" }, "Your new password must be different from previously used password.", -1))
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "desktop--content--footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Reset my password ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-arrow-left" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Back to Login ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--img--wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "banner"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createBlock(_component_el_container, {
        key: 0,
        direction: "vertical"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_header, null, {
            "top-left": _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "/login",
                class: "back-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Form, {
            as: "el-form",
            class: "form-box",
            "validation-schema": _ctx.schema,
            onSubmit: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_app_input, {
                name: "newPassword",
                label: "New Password",
                type: "password",
                "show-password": ""
              }),
              _createVNode(_component_app_input, {
                label: "Verify Password",
                name: "confirmPassword",
                type: "password",
                "show-password": ""
              }),
              _createVNode(_component_app_button, {
                type: "primary",
                "native-type": "submit",
                class: "w-100 el-button-lg",
                round: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["validation-schema", "onSubmit"])
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Form, {
              as: "el-form",
              "validation-schema": _ctx.schema,
              onSubmit: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_app_input, {
                      name: "newPassword",
                      label: "New Password",
                      type: "password",
                      "show-password": ""
                    }),
                    _createVNode(_component_app_input, {
                      label: "Verify Password",
                      name: "confirmPassword",
                      type: "password",
                      "show-password": ""
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "large",
                    class: "w-100 desktop--content--footer-btn",
                    "native-type": "submit",
                    round: "",
                    "control-class": "mb-48"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "back-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["validation-schema", "onSubmit"])
          ])
        ]),
        _hoisted_18
      ]))
}